import { render, staticRenderFns } from "./pendingBetListOthersExportFull.vue?vue&type=template&id=1bea4be0&lang=pug"
import script from "./pendingBetListOthersExportFull.vue?vue&type=script&lang=js"
export * from "./pendingBetListOthersExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports